import { Color, Plugin } from 'chart.js';

const darkMode =
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

const defaultColor = darkMode ? 'white' : 'black';

const significantSegment = 'min-to-avg';

export const minAvgMaxDrawZeros: Plugin = {

  id: 'minAvgMaxDrawZeros',

  afterDatasetsDraw: (
    chart,
    _,
    options: {
      enabled?: boolean;
      color?: Color;
      lineWidth?: number;
    },
  ) => {

    if (!options.enabled) {
      return;
    }

    const color = options?.color ?? undefined;
    const lineWidth = options?.lineWidth ?? 2;

    const horizontal = chart.options.indexAxis === 'y';

    const {ctx} = chart;

    chart.data.datasets
      .forEach((dataset: any, datasetIndex: any) => {
        if (dataset.segment !== significantSegment) {
          return;
        }

        const meta = chart.getDatasetMeta(datasetIndex);

        if (!meta || meta.hidden) {
          return;
        }

        meta.data.forEach((bar: any, i: number) => {

          const min = dataset.originalMin?.[i];
          const avg = dataset.originalAvg?.[i];
          const max = dataset.originalMax?.[i];

          if (min === undefined
            || avg === undefined
            || max === undefined) {
            return;
          }

          const zeroSizeBar = (min === avg && avg === max);

          if (zeroSizeBar) {

            const {x, y} = bar.getProps(['x', 'y'], true);

            ctx.save();
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = color || dataset.borderColor || defaultColor;
            ctx.beginPath();

            if (horizontal) {

              const halfBarHeight = bar.height / 2;

              ctx.moveTo(x, y - halfBarHeight);
              ctx.lineTo(x, y + halfBarHeight);

            } else {

              const halfBarWidth = bar.width / 2;

              ctx.moveTo(x - halfBarWidth, y);
              ctx.lineTo(x + halfBarWidth, y);
            }

            ctx.stroke();
            ctx.restore();
          }
        });
      });
  }
};
